module.exports = __webpack_public_path__ + "img/logo_m.7e2f295c.png";